import cardHover from './hover';

const card = {
  interactive: {
    ...cardHover,
    boxShadow: 'cardList'
  },
  raised: {
    boxShadow: 'cardList'
  }
};

export default card;
